import { ModelBase } from 'store/model-base';
import { CmsQuickpayBreadcrumbs } from '../quickpay/quickpay-breadcrumbs';

export class CmsRetryPayment extends ModelBase {
    public static storeName: string = 'cmsRetryPayment';

    public header: string;
    public summary: CmsRetryPaymentSummary;
    public progressBar: CmsQuickpayBreadcrumbs;
    public start: CmsRetryPaymentStart;
    public card: CmsRetryPaymentCard;
    public review: CmsRetryPaymentReview;
    public result: CmsRetryPaymentResult;
    public cancelBtn: string;
}
